"use client";

import React from "react";
import { Truck, HandHeart, ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const brandValues = [{
  title: "Napredna Dijagnostika",
  description: "Identificiramo slabe točke vašeg baterijskog paketa koristeći vrhunske mjerne instrumente i testere.",
  icon: Truck
}, {
  title: "Vrhunska Kvaliteta",
  description: "Koristimo isključivo certificirane A-grade ćelije visokog kapaciteta za maksimalni doseg i dugovječnost.",
  icon: HandHeart
}];
export default function OurStory() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221835" id="obnova-i-dijagnostika-baterija" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 bg-secondary p-8 sm:p-12 lg:p-20 relative z-10 transition-all duration-[800ms] ease-[cubic-bezier(0.22,1,0.36,1)] ${textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="max-w-xl">
              <h2 className="font-default text-4xl lg:text-5xl leading-tight text-foreground mb-8">
                Profesionalna obnova i dijagnostika baterija
              </h2>
              
              <div className="space-y-6 font-sans text-muted-foreground text-lg leading-relaxed mb-12">
                <p>
                  U ChargeZone servisu koristimo najnaprednije mjerne uređaje za preciznu dijagnostiku zdravlja vaših baterijskih ćelija. Naš proces osigurava da vaša baterija ponovno dobije puni kapacitet, stabilnost i sigurnost pri svakom punjenju.
                </p>
                <p>
                  Specijalizirani smo za reparaciju baterijskih paketa, zamjenu neispravnih ćelija i optimizaciju BMS sustava. Svaki obnovljeni paket prolazi rigorozna testiranja pod opterećenjem u realnim uvjetima prije nego što ga vratimo na vaš romobil.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-12">
                {brandValues.map((value, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
                    <div className="bg-primary w-12 h-12 rounded-sm flex items-center justify-center shadow-sm">
                      <value.icon strokeWidth={1.5} className="size-6 text-primary-foreground" />
                    </div>
                    <div>
                      <h3 className="font-default text-xl font-semibold text-foreground mb-2">
                        {value.title}
                      </h3>
                      <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>)}
              </div>

              <Button asChild variant="outline" size="lg" className="rounded-sm border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                <Link to="#">
                  Saznaj više o servisu
                  <ArrowRight strokeWidth={1.5} className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative z-20 mt-12 lg:mt-0 lg:-ml-16 transition-all duration-[800ms] ease-[cubic-bezier(0.22,1,0.36,1)] delay-200 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="shadow-2xl bg-background p-2 border border-border">
              <AspectRatio ratio={3 / 4}>
                <img src="https://charge-zone.com/wp-content/uploads/2026/04/366b4354-4c9e-48a6-bc7f-12e372e694a7.jpg" alt="Tehničar servisira bateriju električnog romobila" className="object-cover w-full h-full grayscale-[0.2] hover:grayscale-0 transition-all duration-700" />
              </AspectRatio>
            </div>
          </div>

        </div>
      </div>
    </section>;
}